class ModuleSettings {
  backgrounds: NodeList;

  constructor() {
    this.backgrounds = document.querySelectorAll('[data-bg_desktop], [data-bg_mobile]');
    this.setChanges();
    window.addEventListener('resize', this.setChanges);
  }

  setChanges = () => {
    this.setBackground();
  }

  setBackground = () => {
    if (this.backgrounds) {
      this.backgrounds.forEach((item: HTMLElement) => {
        if (window.innerWidth > 767 && item.dataset.bg_desktop) {
          if (item.dataset.bg_desktop.includes('url')) {
            item.style.backgroundImage = item.dataset.bg_desktop;
            item.classList.add(item.dataset.bg_pos_desktop);
            item.classList.add(item.dataset.bg_size_desktop);
            item.style.backgroundRepeat = 'no-repeat';
          }
          else {
            item.style.backgroundColor = item.dataset.bg_desktop
          }
        } else if (window.innerWidth <= 767 && item.dataset.bg_mobile) {
          if (item.dataset.bg_mobile.includes('url')) { // Corrected line
            item.style.backgroundImage = item.dataset.bg_mobile;
            item.classList.add(item.dataset.bg_pos_mobile);
            item.classList.add(item.dataset.bg_size_mobile);
            item.style.backgroundRepeat = 'no-repeat';
          }
          else {
            item.style.backgroundColor = item.dataset.bg_mobile
          }
        } else if (item.style.backgroundImage) {
          item.style.background = null;
        }
      });
    }
  }
}

new ModuleSettings;